import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["comparingWith", "compareButton", "compareListButton", "resetButton", "otherActions"]

  connect() {
    this.mobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)

    let ctrl = this
    this.listObserver = new MutationObserver(function() {
      ctrl.updateVisibility()
    });

    if (this.element && this.element.querySelector("#filterrific_results")) {
      this.listObserver.observe(this.element.querySelector("#filterrific_results"), { attributes: false, childList: true, subtree: true });
    }
  }

  disconnect() {
    this.listObserver.disconnect()
  }

  updateVisibility(button = null) {
    if (this.comparingtId) {
      this.comparingWithTarget.classList.remove("hidden")
      this.resetButtonTarget.classList.remove("hidden")
      this.compareListButtonTargets.map(target => target.classList.remove("hidden"))
      this.otherActionsTargets.map(target => target.classList.add("hidden"))

      if (button) {
        button.classList.add("hidden")
        button.nextSibling.classList.add("hidden")
      }
    } else {
      this.comparingWithTarget.classList.add("hidden")
      this.resetButtonTarget.classList.add("hidden")
      this.compareListButtonTargets.map(target => target.classList.add("hidden"))
      this.compareButtonTargets.map(target => target.classList.remove("hidden"))
      this.otherActionsTargets.map(target => target.classList.remove("hidden"))
    }
  }

  compare() {
    event.preventDefault()

    if (this.comparingtId) {
      let url = event.currentTarget.getAttribute("data-compare-url").replace("another-id", this.comparingtId)

      if (event.currentTarget.getAttribute("data-content") === "true") {
        this.loadModalContent(url, "Comparing Changes List", null)
      } else {
        this.loadModalIframe(url, "Comparing Visual Diff", null)
      }
    } else {
      this.comparingtId = event.currentTarget.getAttribute("data-result-id")
      this.comparingWithTarget.innerText = `Comparing with: ${event.currentTarget.getAttribute("data-result-time")}`
      this.updateVisibility(event.currentTarget)
    }
  }

  resetCompare() {
    this.comparingtId = null
    this.comparingWithTarget.innerText = ""
    this.updateVisibility()
  }

  loadModal() {
    event.preventDefault()

    let button = event.currentTarget

    if (button.getAttribute("data-content") === "true") {
      this.loadModalContent(button.getAttribute("href"), button.getAttribute("data-title"), null)
    } else {
      this.loadModalIframe(button.getAttribute("href"), button.getAttribute("data-title"), $content =>
        // show diffs on hidden elements
        $.each($content.find('.urlooker-i:hidden, .urlooker-d:hidden'), function (_, element) {
          const $element = $(element);
          $element.parents(':hidden').show();
          $element.show();
        })
      )
    }
  }

  loadModalIframe (url, title, onload) {
    let original_viewport
    if (onload == null) { onload = function() {}; }
    if (this.mobile) {
      original_viewport = $("#viewport").attr("content")
      $("#viewport").attr("content", "user-scalable=yes,width=2000")
    }

    const $modal = $('#dynamic-modal')
    $modal.find(".iframe-wrapper").removeClass("hidden")
    $modal.find(".content-wrapper").addClass("hidden")
    const $iframe = $modal.find('iframe')
    const $loader = $modal.find('.loader')
    $loader.show()

    $modal.find(".modal-title").text(title)
    $iframe.attr('src', url)
    const height = window.innerHeight || document.body.clientHeight || document.documentElement.clientHeight
    $iframe.attr('height', height - 200)
    $iframe.on('load', function() {
      const $content = $iframe.contents()

      $content.find('a').click(e => e.preventDefault())

      onload($content)

      $loader.hide()
      $iframe.removeClass('hidden')
    })

    $modal.modal({show: true, keyboard: true})
    $modal.on('hidden.bs.modal', function() {
      $iframe.addClass('hidden')
      $loader.show()
      $iframe.attr('src', 'about:blank')
      if (this.mobile) {
        $("#viewport").attr("content", original_viewport)
      }
    })
  }

  loadModalContent (url, title, onload) {
    let original_viewport
    if (onload == null) { onload = function() {}; }
    if (this.mobile) {
      original_viewport = $("#viewport").attr("content")
      $("#viewport").attr("content", "user-scalable=yes,width=2000")
    }

    const $modal = $('#dynamic-modal')
    $modal.find(".iframe-wrapper").addClass("hidden")
    const $loader = $modal.find('.loader')
    $loader.show()

    $modal.find(".modal-title").text(title)

    $.ajax({
      url: url,
      success: function(html) {
        $loader.hide()
        $modal.find(".content-wrapper").html(html)
        $modal.find(".content-wrapper").removeClass("hidden")
      },
      dataType: 'html'
    })

    $modal.modal({show: true, keyboard: true})

    $modal.on('hidden.bs.modal', function() {
      $loader.show()
      if (this.mobile) {
        $("#viewport").attr("content", original_viewport)
      }
    })
  }
}
